<!--A md-datepicker wrapper to fix remove date bug-->

<template>

  <md-datepicker v-model="modelDate"
  :md-disabled-dates="disabledDates">
    <slot/>
  </md-datepicker>

</template>
<script>
import moment from 'moment';
  export default {
    props: {
      name: String,
      value: [String, Date],
    },
    data: () => ({
      modelDate: null,
      disabledDates: date => {
        const day = moment(date)
        return !(moment().diff(day, 'days') <= 0)
      } 

    }),
    watch: {
      modelDate(val) {
        console.log(` modelDate=${val},value=${this.value}`);
        this.$emit('input', val);
        if (val) {
          this.$nextTick(() => {
            const element = this.$el.querySelector('button.md-clear');
            $(element).click(() => {
              console.log(`$emit`);
              this.$emit('input', null);
            });
          });
        }
      },
      value(val) {
        console.log(` value=${val},modelDate=${this.modelDate}`);
        this.modelDate = val;
      },
    },
    created() {
      console.log(` created this.value=${this.value}`);
      this.modelDate = this.value;
      this.$emit('input', this.value);
    },
  };
</script>
